<template>
  <el-dialog
  :visible="dialogVisible"
  :fullscreen="true"
  :close-on-press-escape="false"
  :show-close="false"
  :append-to-body="true"
  center
  v-loading.fullscreen.lock="loading"
  @open="open">
  <span slot="title" class="dialog-header">
    <span  class="title" >{{title}}</span>
  </span>
  <el-row justify="center">
    <el-col class="formContainer" :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
      <el-form label-position="top" label-width="100px" :rules="rules" ref="soForm" :model="salesOrder">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item :label="$t('common.customer')" >
                <SelectCustomerComponent :active="true" :customer="salesOrder.customer" @selected="selectCustomer"></SelectCustomerComponent>
              </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item :label="$t('sales_orders.Sales_order_number')">
                <el-input :value="salesOrder.soNumber" :disabled="true"></el-input>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isSelectedCustomerHasOverdue">
          <el-col><div class="card-shadow--small bg-danger-lighter p-10 m-10"><span><i class="el-icon-warning"></i> {{$t('clients.overdueWarning')}}</span>{{ formatAmount(overdue) }}</div></el-col>
        </el-row>
        <el-row :gutter="20" v-if="salesOrder.customer" class="animated fadeIn">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-row v-if="salesOrder.customer.type==1">
              <el-form-item :label="$t('sales_orders.billedTo')" prop="billingContact">
                <el-select :value="salesOrder.billingContact" @change="setBillingContact" value-key="id" placeholder="Select">
                  <el-option
                    v-for="c in customerContacts"
                    :key="c.id"
                    :disabled="!c.active"
                    :label="getName(c)"
                    :value="c">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row v-if="salesOrder.billingAddress">
              <DefaultAddressCard :address="salesOrder.billingAddress"  :adresseTypeName="billingAddressName"></DefaultAddressCard>
            </el-row>
            <el-row v-else>
              <div>
                <span v-if="salesOrder.customer.type!=1"><strong>{{$t('sales_orders.billedToField')}}</strong></span> {{$t('invoices.noBilledAddress')}}
              </div>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-row v-if="salesOrder.customer.type==1">
              <el-form-item :label="$t('sales_orders.Deliver_to')" prop="shipping_contact_id">
                <el-select :value="salesOrder.shippingContact" @change="setShippingContact" value-key="id" placeholder="Select">
                  <el-option
                    v-for="c in customerContacts"
                    :key="c.id"
                    :label="getName(c)"
                    :disabled="!c.active"
                    :value="c">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row v-if="salesOrder.shippingAddress">
                <DefaultAddressCard :address="salesOrder.shippingAddress" adresseTypeName="Livraison"></DefaultAddressCard>
            </el-row>
            <el-row v-else>
              <div>
                <span v-if="salesOrder.customer.type!=1"><strong>{{$t('sales_orders.Deliver_toField')}}</strong></span> {{$t('sales_orders.No_shipping_address_specified')}}
              </div>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item :label="$t('invoices.salesRep')" prop="rep">
                <el-select :value="salesOrder.rep" value-key="id" placeholder="Select" @change="setSalesRep" clearable>
                    <el-option
                      v-for="user in filterUserWithRoleRep"
                      :key="user.id"
                      :label="user.firstName + ' ' + user.lastName"
                      :value="user">
                    </el-option>
                  </el-select>
                </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item :label="$t('sales_orders.Reference_number')">
                <el-input v-model="reference" ></el-input>
              </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item :label="$t('sales_orders.tags')">
            <el-select
                v-model="tags"
                multiple
                filterable
                allow-create
                :placeholder="$t('sales_orders.tags')"
                value-key="id">
                <el-option
                  v-for="item in listTags"
                  :key="item.id"
                  :label="item.code"
                  :value="item">
                </el-option>
              </el-select>
          </el-form-item>
        </el-row>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item :label="$t('sales_orders.salesOrderDate')" prop="date" style="width:100%" :error="dateError"  :required="dateRequired">
                <template slot="error" slot-scope="scope">
                  <div class="el-form-item__error">{{dateError}}</div>
                </template>
                <el-date-picker v-model="date" type="date"></el-date-picker>
              </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" >
              <el-form-item :label="$t('sales_orders.expectedDeliveryDate')" prop="deliveryDate" >
                <el-date-picker v-model="expectedDeliveryDate" type="date"  :picker-options="datePickerOptions"></el-date-picker>
                <el-checkbox v-model="noRestriction" class="ml-5">{{$t('sales_orders.removeDeliveryDateRestrictions')}}</el-checkbox>
              </el-form-item>

          </el-col>

        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">

            <el-form-item :label="$t('clients.deliveryType')" prop="deliveryType">
              <el-select :value="salesOrder.deliveryType"  @change="setShippingMethodId" value-key="id">
                  <el-option
                    v-for="type in deliveryTypesByLanguage($i18n.locale)"
                    :key="type.id"
                    :label="type.name"
                    :value="type">
                  </el-option>
                </el-select>
            </el-form-item>

          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="showDeliveryLocation" >
              <el-form-item :label="$t('sales_orders.branch')" >
                <el-select v-model="location" filterable no-data-text="" placeholder="Select" value-key="id" @change="handleSelecteLocation">
                  <el-option
                    v-for="item in formattedLocations"
                    :key="item.id"
                    :label="item.formated"
                    :value="item">
                  </el-option>
                </el-select>
                <!-- <el-autocomplete class="inline-input" v-model="location" :trigger-on-focus="false"  style="width:100%;" :fetch-suggestions="searchLocation" placeholder="Sélectionner une succursale" @select="handleSelecteLocation">
                  <i
                    class="el-icon-search el-input__icon"
                    slot="suffix">
                  </i>
                  <template slot-scope="{ item }">
                    <BranchTile :location="item.content"></BranchTile>
                  </template>
                </el-autocomplete> -->
              </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <h3>{{$t('sales_orders.salesOrderDetail')}}</h3>
        <div  class="sticky">
          <el-row>
            <el-radio-group v-model="source">
              <el-radio-button label="Inventaire">{{ $t('sales_orders.inventory') }}</el-radio-button>
              <el-radio-button :label="reservationLabel">{{ $t('sales_orders.reservationWithNumber', [numberOfReservation]) }}</el-radio-button>
            </el-radio-group>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="source=='Inventaire'">
              <el-form-item :label="$t('sales_orders.inventoryProductType')">
                <el-select v-model="selectedInventory"  @change="handleInventorySelection">
                <el-option-group
                  v-for="group in inventoriesService"
                  :key="group.label"
                  :label="group.label">
                  <el-option
                    v-for="item in group.options"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-option-group>
              </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="source=='Inventaire'">
                <el-form-item :label="$t('sales_orders.selectProduct')">
                  <el-autocomplete class="inline-input" :disabled="salesOrder.customer==null" :trigger-on-focus="false" value-key="puid" v-model="itemSelected" style="width:100%;" :fetch-suggestions="querySearch" :placeholder="$t('sales_orders.selectProduct')" @select="handleSelect">
                    <template slot-scope="{ item }">
                      <ItemTemplate :product="item" :quantity="item.quantity" :showInventoryName="false" :inventory="item.inventory" :format="item.format" :volume="item.volume"></ItemTemplate>
                    </template>
                  </el-autocomplete>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="isReservationModuleActive && source!='Inventaire'" >
                <el-form-item :label="$t('sales_orders.selectReservation')">
                  <el-autocomplete class="inline-input" :disabled="salesOrder.customer==null" value-key="item_name" v-model="selectedReservation" style="width:100%;" :fetch-suggestions="querySearchReservation" :placeholder="$t('sales_orders.selectReservation')" @select="handleSelectReservation">
                    <template slot-scope="{ item }">
                      <reservationTile
                        :reservation="item"
                         :showSalesRep="false"
                         style="line-height:16px;" />
                    </template>
                  </el-autocomplete>
                </el-form-item>
            </el-col>
          </el-row>
        </div>
        <SalesOrderItemsEditor
          class="m-10"
          :items="salesOrder.lines"
          :editControls="true"
          @quantityChange="setQuantity"
          @editPrice="editPrice"
          @changePrice="setPrice"
          @changeDiscount="setDiscount"
          @remove="removeItemLine"
          @removeRebates="removeRebates"
          @removeLines="removeLines"
          @applyDiscount="applyDiscount"
          @edition="v => disableButton(v)" />
        <el-row>
          <table style="width:100%;margin-top:20px;">

              <tr>
                <td class="fs-14 secondary-text font-weight-800" style="text-align:right;">{{$t('sales_orders.subTotalField')}}</td>
                <td class="fs-14 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(salesOrder.subTotal,'currency')}}</td>
              </tr>
              <tr>
                <td class="fs-14 secondary-text" style="text-align:right;"><span v-if="salesOrder.discount != null">{{$t('sales_orders.rebateField')}} </span></td>
                <td class="fs-14 secondary-text" style="text-align:right;width:150px;">
                  <el-link :underline="false" type="primary" slot="reference" @click="openRebateCreditDrawer(salesOrder.discount)">
                    <span v-if="salesOrder.discount==null">{{$t('sales_orders.rebate')}} <i class="el-icon-circle-plus" ></i></span>
                    <div v-else>
                      <span v-if="salesOrder.discount.type==1">({{salesOrder.discount.value}}%) ({{$n(salesOrder.discount.amount, 'currency')}})</span>
                      <span v-else>
                        <span v-if="salesOrder.discount.netType=='TOTAL'">({{$n(salesOrder.discount.value, 'currency')}})</span>
                      </span>
                    </div>
                  </el-link>
                </td>
              </tr>
              <tr v-for="(tax, index) in salesOrder.taxes" :key="index">
                <td class="fs-14 secondary-text" style="text-align:right;">{{tax.label}} <span class="hidden-md-and-down">({{tax.taxNumber}})</span> : </td>
                <td class="fs-14 secondary-text" style="text-align:right;width:150px;">{{$n(tax.total,'currency')}}</td>
              </tr>
              <tr>
                <td class="fs-14 secondary-text font-weight-800" style="text-align:right;">{{$t('sales_orders.totalField')}}</td>
                <td class="fs-14 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(salesOrder.total,'currency')}}</td>
              </tr>
              <tr v-if = "showTotalBillableAmount">
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;">{{ $t('sales_orders.totalBillableAmount') }} </td>
              <td class="fs-14 secondary-text font-weight-800" style="text-align:right;width:150px;">{{$n(getTotalBillableAmount,'currency')}}</td>
            </tr>
          </table>
        </el-row>
      <el-row :gutter="20">
        <el-col >
          <el-form-item label="Notes">
            <el-input type="textarea" :rows="5" resize="none" v-model="notes"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      </el-form>
    </el-col>
  </el-row>
  <span slot="footer" class="dialog-footer card-shadow--large">
    <el-button @click="closeDialog">{{ $t('common.Cancel') }}</el-button>
    <el-dropdown class="ml-5" v-if="salesOrder.status==null">
      <el-button type="primary" :disabled="buttonDisabled || salesOrder.detailItemsLoading ">
        {{ $t('common.save') }}<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item  @click.native="save('save')"  :disabled="buttonDisabled || salesOrder.detailItemsLoading">{{ $t('common.save') }}</el-dropdown-item>
        <el-dropdown-item @click.native="save('emit')" v-if="salesOrder.status == null" :disabled="buttonDisabled || salesOrder.detailItemsLoading || salesOrderLinesEmpty">{{$t('common.saveAndConfirm')}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-button v-else type="primary"  @click.native="save('save')"  :disabled="buttonDisabled || salesOrder.detailItemsLoading">{{ $t('common.save') }}</el-button>
  </span>
  <RebateDrawer :visible="rebateDrawerVisible" :showNetType="false" :rebateToEdit="rebateToEdit" @close="closeRebateCreditDrawer" @update="v=> handleDiscount(v.rebate)"> </RebateDrawer>
  </el-dialog>
</template>
<script>
import customerAPI from '@/services/API/customer'
import systemAPI from '@/services/API/system'
import moment from 'moment-business-days'
import dayjs from 'dayjs';
import { mapActions, mapState, mapGetters } from 'vuex';
import DefaultAddressCard from '@/components/address/Default-Address-Card'
import ItemTemplate from '@/components/product/item-template-v2'
import reservationTile from '@/components/reservation/reservation-tile-v2'
import customerUtil from '@/utils/customer-util.js'
import RebateDrawer from '@/components/sales-order-rebate-drawer';
import BranchTile from '@/components/Branch-tile'
import SalesOrderItemsEditor from '@/components/salesOrder/sales-order-items-editor'
import ContactUtils from '@/utils/contact-utils.js'
import portausUtils from '@/utils/portaus-utils';
import SelectCustomerComponent from '@/components/customer/select-customer-autocomplete'
import CustomerUtil from '@/utils/customer-util'
import InventoryAPI from '@/services/API/inventory'
import ProductAPI from '@/services/API/product'
export default {
  name: 'CreateSalesOrderDialog',
	props: {
		dialogVisible : Boolean,
    editSelectedSalesOrder : {
        type : Object,
        default : null
    },
    customerId : {
      type : String,
      default : null,
    }
	},
  data() {
    return {
      listTags : [],
      noRestriction : false,
      source : 'Inventaire',
      // date : null,
      itemSelected : null,
      selectedReservation : null,
      // expectedDeliveryDate : null,
      selectedInventory : null,
      customers : [],
      customersLoading : false,
      formModel : null,
      selectedCustomer : null,
      inventoriesService : [],
      buttonDisabled : false,
      rebateDrawerVisible: false,
      rebateDrawerVisible : false,
      rebateToEdit :null,
      rules : {
        deliveryType : [
          { required: true, message: 'Veuillez saisir un contact de facturation.', trigger: 'blur' }
        ],
        billingContact : [
          { required: true, message: 'Veuillez saisir un contact de facturation.', trigger: 'blur' }
        ],
        shippingContact : [
            { required: true, message: 'Veuillez saisir un contact de livraison.', trigger: 'blur' }
        ]
      },
      currentRow : null,
      datePickerOptions: {
        disabledDate :this.restrictDateNotEqualAtSchedule
      }
    };
  },components: {
    DefaultAddressCard,
    ItemTemplate,
    reservationTile,
    RebateDrawer,
    BranchTile,
    SalesOrderItemsEditor,
    SelectCustomerComponent
  },
	methods: {
    formatAmount(amount) {
        return portausUtils.formatAmount(amount, this.$i18n.locale);
    },
    openRebateCreditDrawer (discount) {
      this.rebateToEdit = discount;
      this.rebateDrawerVisible=true;
    },
    closeRebateCreditDrawer(){
      this.rebateDrawerVisible=false;
    },
    handleDiscount(discount) {
      this.setGlobalDiscount(discount);
    },
    getCustomerName (customer) {
      return CustomerUtil.customerName(customer.name, customer.usual_name || customer.usualName);
    },
    isProductPresentInItemLine (productId) {
      return _.find(this.salesOrder.items, i=> i.productId === productId) != null
    },
    disableButton(disabled){
      this.buttonDisabled = disabled;
    },
    addCurrentTagIfNotPresent(listTags, currentTags){
      _.forEach(currentTags, t=>{
        let tagFound = _.find(listTags, t2=>{return t2.code==t.code});
        if(tagFound==null){
          this.listTags.push(t);
        }
      })
    },
    customerEmail(customer){
      return customerUtil.customerEmail(customer);
    },
    handleInventorySelection(inventory){
      this.itemSelected='';
    },
    searchCustomers(queryString, cb){
        this.fetchSearchedCustomers(queryString)
          .then(customers=>{
            cb(customers);
          })
    },
    setPrice({uuid, price, priceIndex}){
      this.setItemLineProp({uuid, itemProp:{price}, priceIndex});
    },
    setQuantity({uuid, quantity}){
      this.setQtyOrdered(uuid, quantity);
    },
    getName(contact){
      return ContactUtils.getName(contact);
    },
    restrictDateNotEqualAtSchedule(date){
      
      const today = new Date();

      if(date <= today) {
        return true;
      }

      if(this.noRestriction) {
        return false;
      }
      if(this.deliverySchedule.length==0) {
        return false;
      }
      let dateSdheduled =  _.find(this.deliverySchedule, schedule=>{return schedule.active&&schedule.day-1==moment(date).day()});
      return dateSdheduled == null;
    },
    removeAccent(str){
      return str
         .replace(/[áàãâä]/gi,"a")
         .replace(/[éè¨ê]/gi,"e")
         .replace(/[íìïî]/gi,"i")
         .replace(/[óòöôõ]/gi,"o")
         .replace(/[úùüû]/gi, "u")
         .replace(/[ç]/gi, "c")
         .replace(/[ñ]/gi, "n")
         .replace(/[^a-zA-Z0-9]/g,"");
    },
   
    searchLocation(queryString, cb){
      var location = [];
      if (_.get(this.salesOrder, 'deliveryType.choice_custom_info') === 'SAQ') {
        if (_.get(this.salesOrder, 'customer.customer_class.ind') === 'TITULAIRE') {
          location =  this.getPrivateImportTPSAQBranch;
        } else {
          location = this.getPrivateImportPatriculierSAQBranch;
        }
      }
      
      var results = queryString ? location.filter(this.createLocationFilter(queryString)) : location;
      // call callback function to return suggestion objects
      cb(results);
    },
    createLocationFilter(queryString) {
      return (location) => {

        return (location.content.number.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 ||
                this.removeAccent(location.content.city.toLowerCase()).indexOf(this.removeAccent(queryString.toLowerCase())) !== -1 ||
               this.removeAccent(location.content.address.toLowerCase()).indexOf(this.removeAccent(queryString.toLowerCase())) !== -1);
      };
    },
    getInStockQty(item){
      if(item.quantities!=null){
        return item.quantities.in_stock;
      }else{
        return "";
      }
    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);
    },
    changeCurrentRow(row,column,cell, event){
      this.currentRow=row;
    },
    querySearch(queryString, cb){

      if (this.selectedInventory !== -1) {
        return InventoryAPI.fetchProductsV2({ inventoryId: this.selectedInventory, searchTerms: queryString, paging: 'no', limit:25, available: true}, this.selectedInventory)
          .then(products => {
            cb(products);
          })
      } else {
        return ProductAPI.listProductsV2({ type: 0, paging: 'no', searchTerms: queryString})
        .then(products => {
          cb(products);
        })
      }

    },
    querySearchReservation(queryString, cb){
      var reservations = this.getAvailableCustomerReservations;
       var results = queryString ? reservations.filter(this.createFilter(queryString)) : reservations;
       // call callback function to return suggestions
       cb(results);
    },
    createFilter(queryString) {
      return (item) => {
        let str = item.product.name;

        if(item.product.provider!=null){
          str+=item.product.provider.name;
          if(item.product.provider.usual_name!=null){
            str+=item.product.provider.usual_name
          }
        }
        return (_.deburr(str).toLowerCase().indexOf(_.deburr(queryString).toLowerCase()) >= 0);
      };
    },
    handleSelecteLocation(selectedLocation){
      this.setDeliveryLocation(selectedLocation)
    },
    handleSelectReservation(selectedReservation){
      this.addReservedItemLine(selectedReservation)
        .then(()=>{
          this.selectedReservation=null;
        })
    },
    handleSelect(selectedItem){
      this.addItemLineItem(selectedItem)
        .then((status)=>{
          if(status != 'AVAILABLE') {
            this.$notify({
                title: 'Quantité en inventaire',
                message: "Le produit sélectionné n'est plus disponible",
                type: 'warning'
              });
          }
          this.itemSelected=null;
        }).catch(err=>{

        })
    },
    open(){

      this.fetchInventories()
        .then(()=>{
          this.inventoriesService = [{label:this.$i18n.t('sales_orders.inventory'), options : []}];
          _.forEach(this.inventories, i=>{
            this.inventoriesService[0].options.push({id:i.id, name:i.name});
          })
          this.inventoriesService.push({label:'Service', options : [{id:-1, name:this.$i18n.t('sales_orders.serviceProduct')}]});
        })
      // this.inve
      this.fetchTags()
        .then(()=>{
          if(this.editSelectedSalesOrder!=null){
            this.addCurrentTagIfNotPresent(this.listTags, this.editSelectedSalesOrder.tags);
          }
        })
      this.selectedInventory = _.get(this.defaultInventory, 'id');
      if (this.selectedInventory == null) {
        this.selectedInventory = _.get(_.head(this.inventories), 'id');
      }
      if(this.editionMode){
        if(this.editSelectedSalesOrder.customer!=null){
          this.fetchSearchedCustomers(this.editSelectedSalesOrder.customer.name)
          this.selectedCustomer = this.editSelectedSalesOrder.customer.name;
        }

        this.transformSelectedSalesOrderToEditionMode(this.editSelectedSalesOrder);
        // this.expectedDeliveryDate = this.salesOrder.expectedDeliveryDate;
        this.date = this.salesOrder.date;
      }else{
        if (this.customerId != null) {
          this.getCustomer(this.customerId)
            .then((customer) => {
              this.setSalesOrderCustomer({ customer });
              this.selectedCustomer = customer;
            })
        }
        this.date = new Date();
        this.setSalesOrder({date:this.date});
        let user = JSON.parse(localStorage.user);
        if(_.find(user.roles, r=>{return r.role_name==='Rep'})){
          this.setSalesOrder({salesRepId : user.id});
        }
      }
      // this.fetchStockItems();
      




    },
    selectCustomer(selectedCustomer, withoutRep = false){
      if(_.get(selectedCustomer, 'id') != null){
        customerAPI.getCustomer(selectedCustomer.id)
          .then((customer)=>{
            this.setSalesOrderCustomer({ customer, withoutRep});
            this.initPrice();
          })
      }
    },
    setDate(date){
      if(date==NaN){
        this.setSalesOrder({date:null})
      }else{
        this.setSalesOrder({date})
      }

    },
    setSalesRep(rep){
      this.setSalesOrder({rep});
    },
    setShippingMethodId(deliveryType){
      this.setShippingMethod(deliveryType);
    },
    setCredit(credit){
      this.setSalesOrder({credit});
    },
    setDeliveryFee(deliveryFee){
      this.setSalesOrder({deliveryFee});
    },
    setQtyOrdered(uuid,qty){
      this.setItemLineProp({uuid, itemProp:{qty}});
    },
    setUnitPrice(unitPrice, uuid){
      this.setItemLineProp({uuid, itemProp:{unitPrice}});
    },
    setDescription(description, uuid){
      this.setItemLineProp({uuid, itemProp:{description}});
    },
    setDiscount({discount,uuid}){
      this.setItemLineProp({uuid, itemProp:{discount}});
    },
    closeDialog(){
      this.reset();
      this.selectedCustomer=null;
      this.$emit('close');
    },
    fetchTags(){
      return systemAPI.getTags('SALES_ORDER',true)
        .then(tags=>{
          this.listTags = tags;
        })
    },
    save(action){

      let saveFunction = !this.editionMode?this.postSalesOrder:this.putSalesOrder;

      this.$refs['soForm'].validate((valid)=>{
        this.validate(action) //Store validation
          .then(salesOrderValid=>{
            if(valid && salesOrderValid){

              saveFunction(action)
                .then(result=>{
                  this.invalidateStockItems();
                  if(!this.editionMode){
                    let id = result!=null?result.id:this.editSelectedSalesOrder.id;

                    var index = '/sales-orders/' + id;
                    this.$router.push(index)
                    this.$emit('push-page', {page:index})
                    this.reset();
                  }else{
                    this.setSelectedSalesOrder(this.salesOrder);
                    this.closeDialog();
                  }

                }).catch(err=>{
                  if(err!=='cancel'){ // S'il y a une confirmatiomn de modification
                    if(err.response!=null && err.response.data.jse_info!=null){
                      this.$message({message:this.$i18n.t('sales_orders.errors.'+err.response.data.jse_info.errorCode), type:'error'});
                    }else{
                      this.$message({message:this.$i18n.t('Une erreur système est survenur. Veuillez réessayer plus tard.'), type:'error'});
                    }

                  }

                })
            }else{

              if(!valid){
                this.$message({
                    message: "Certains champs obligatoires n'ont pas été renseignés.",
                    type: 'warning'
                  });
              }



            }
          })

      })
    },
    ...mapActions('salesOrderEditor',['validate','postSalesOrder','putSalesOrder','fetchSearchedCustomers','setSalesOrderCustomer','addDefaultItemLine','setSalesOrder','setShippingMethod','removeItemLine','addItemLineItem','addReservedItemLine','setItemLineProp','reset','setBillingContact', 'setShippingContact','transformSelectedSalesOrderToEditionMode','setDeliveryLocation','setLocationName','setExtraInfo','editPrice','setTags','getCustomer', 'initPrice', 'setGlobalDiscount', 'removeRebates','removeLines', 'applyDiscount']),
    ...mapActions('controlData',['fetchDeliveryTypes','fetchLocations']),
    ...mapActions('users',['fetchAdminUsers']),
    ...mapActions('stockItems',['fetchStockItems','invalidateStockItems']),
    ...mapActions('statuses',['fetchSalesOrderStatuses']),
    ...mapActions('salesOrders',['invalidateSalesOrderList','setSelectedSalesOrder']),
    ...mapGetters('reservation', ['isReservationModuleActive']),
    ...mapActions('inventory',['fetchInventories'])
	},
	computed: {
    overdue(){
      return _.get(this.salesOrder, 'customer.balance_account.overdue');
    },
    isSelectedCustomerHasOverdue(){
      return this.overdue > 0;
    },
    formattedLocations() {
      if (_.get(this.salesOrder, 'deliveryType.choice_custom_info') === 'SAQ' || _.get(this.salesOrder, 'deliveryType.choiceCustomInfo') === 'SAQ')  {
        if (_.get(this.salesOrder, 'customer.customer_class.ind') === 'TITULAIRE' || _.get(this.salesOrder, 'customer.class.ind') === 'TITULAIRE') {
          return this.getFormattedPrivateImportTPSAQBranch;
        } else {
          return this.getFormattedPrivateImportPatriculierSAQBranch;
        }
      }
    },
    showTotalBillableAmount () {
        if (this.getTotalBillableAmount == null) return 0;
        return this.getTotalBillableAmount != this.salesOrder.total;
      },
    salesOrderLinesEmpty () {
      return _.isEmpty(this.salesOrder.lines);
    },
    salesOrderItemQuantity(){
      let count = 0;
      _.forEach(this.salesOrder.items, i=> {
        count += i.qty_ordered;
      })
      return count;
    },
    reservationLabel () {
      if (this.numberOfReservation > 0) {
        return 'Réservation (' + this.numberOfReservation + ')';
      }
      return "Réservation";
    },
    numberOfReservation () {
      return this.getAvailableCustomerReservations != null ? this.getAvailableCustomerReservations.length : 0;
    },
    deliverySchedule(){
      return _.filter(_.get(this.salesOrder, 'customer.customer_delivery_schedules'), schedule => schedule.active === true);
      // if(this.salesOrder.customer!=null && this.salesOrder.customer.customer_delivery_schedules!=null){
      //   return this.salesOrder.customer.customer_delivery_schedules;
      // }else{
      //   return [];
      // }
    },
    editionMode(){
      return this.editSelectedSalesOrder!=null;
    },
    title(){
      if(this.editSelectedSalesOrder){
        return this.$i18n.t('sales_orders.sales_order_dialog.title_edit');
      }else{
        return this.$i18n.t('sales_orders.sales_order_dialog.title_new');
      }
    },
    date : {
      set(date){
        if(date==NaN){
          this.setSalesOrder({date:null})
        }else{
          this.setSalesOrder({date})
        }
      },
      get(){return this.salesOrder.date}
    },
    expectedDeliveryDate : {
      set(expectedDeliveryDate){
       
        const dayOfTheWeek = dayjs(expectedDeliveryDate).day() +1;
        const deliveryShedule = _.orderBy(_.get(this, 'salesOrder.customer.customer_delivery_schedules'), 'day');

        const index = _.findIndex(deliveryShedule, schedule => schedule.day === dayOfTheWeek);
        let previousIndex = index - 1;
        let nextIndex = index + 1

        let previousDeliveryDay = null;
        let nextDeliveryDay = null;

        if (index > 0) {
          previousDeliveryDay = _.get(deliveryShedule[index -1], 'day');
        }

        if (index + 1 <= _.size(deliveryShedule)) {
          nextDeliveryDay = _.get(deliveryShedule[index + 1], 'day');
        } else {
          nextDeliveryDay = _.get(deliveryShedule[index], 'day');
        }
        
        let diff = 5;

        if (previousDeliveryDay != null ) {
          diff = dayOfTheWeek - previousDeliveryDay;
        }

        let date = moment(expectedDeliveryDate).businessSubtract(diff);

        if (dayjs(date).day() < nextDeliveryDay) {
          date = moment(expectedDeliveryDate).businessSubtract(diff - (nextDeliveryDay - (dayjs(date).day() +1)));
        }


        if(date<new Date()){
          date = new Date();
        }
        this.setSalesOrder({date:date});
        this.setSalesOrder({expectedDeliveryDate});
      },
      get(){return this.salesOrder.expectedDeliveryDate}
    },
    delivery_fee : {
      set(delivery_fee){this.setSalesOrder({delivery_fee})},
      get(){return this.salesOrder.delivery_fee}
    },
    tags : {
      set(tags){this.setTags(tags)},
      get(){return this.salesOrder.tags;}
    },
    location : {
      set(val){this.setLocationName(val)},
      get(){return this.locationName}
    },
    credit : {
      set(credit) {this.setSalesOrder({credit})},
      get(){return this.salesOrder.credit;}
    },
    notes : {
      set(val){this.setSalesOrder({notes:val})},
      get(){return this.salesOrder.notes}
    },
    reference : {
      set(val){this.setSalesOrder({reference:val})},
      get(){return this.salesOrder.reference}
    },
    billingAddressName(){
      return this.$t("billing_address");
    },shippingAddressName(){
      return this.$t("shipping_address");
    },
    ...mapState('salesOrderEditor', ['searchedCustomers', 'salesOrder','defaultItem','customerContacts', 'itemsLoading','customerReservations', 'dateRequired','dateError','showDeliveryLocation','loading','locationName']),
    ...mapGetters('controlData', [ 'deliveryTypesByLanguage', 'getPrivateImportPatriculierSAQBranch', 'getPrivateImportTPSAQBranch', 'getFormattedPrivateImportTPSAQBranch', 'getFormattedPrivateImportPatriculierSAQBranch']),
    ...mapGetters('users', [ 'filterUserWithRoleRep']),
    ...mapGetters('stockItems', [ 'inStockItems','inStockItemsByInventory']),
    ...mapGetters('salesOrders',['customerName']),
    ...mapGetters('salesOrderEditor',['getCreditItemLineTotal', 'getAvailableCustomerReservations', 'getTotalBillableAmount']),
    ...mapState('inventory',['inventories']),
    ...mapGetters('inventory',['defaultInventory'])
	},
  created(){
    this.fetchDeliveryTypes();
    this.fetchAdminUsers();
    this.fetchSalesOrderStatuses();
    this.fetchLocations();
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';


.sticky {
  position: -webkit-sticky;
  position: sticky;
  top:0px;
  padding-top:20px;
  z-index:1000;
  width:100%;
  background-color:#ffffff;
}

.branch{
  // border-bottom:1px solid #DCDFE6;
  line-height:20px;
  padding-top:10px;
  padding-bottom:10px;
}

.dialog-footer{
  position: fixed;
  display: block;
  bottom: 0px;
  width: 100%;
  background-color: #f3f7fa;
  height:50px;
  margin-left:-20px;
  padding-top:10px;
  border-top:1px solid #E4E7ED;
  z-index:1001;
}

.el-input__inner{
  border:0px;
}
.title {
	font-size : 1.6em;
	font-weight:bold;

}
.product{
  line-height:20px;

  .qty{
    float:right;
    position:relative
  }
  .empty {
    color:red;
  }
}

.formContainer{
    margin-left:15%;
    width:70%;
  }


@media (max-width: 1366px) {
  .formContainer{
      margin-left:10%;
      width:80%;
    }
}

@media (max-width: 1024px) {
  .formContainer{
      margin-left:2%;
      width:98%;
    }
}

</style>
